<template>
<billing-dialog v-model="visible" aria-labelledby="pbx-plan-detail-id-comparison" class="comparison-dialog opc-pbx-comparison-dialog" show-close :before-close="beforeClose" @back-event="onBackEvent">
  <span id="pbx-plan-detail-id-comparison" class="opc_hidden_element">Zoom Phone</span>
  <template #title>
    <h1 class="comparison-dialog__title">{{ $t('billing.pbx.pbx_comparison') }}</h1>
  </template>
  <p @click="onPBXSalesClick" class="comparison-dialog__desc" v-html="$t('billing.pbx.comparison_desc', [pbxContactSalesLink])"></p>
  <!-- V3-TODO: use new components-lib -->
  <PlanComparisonMobile
    v-if="showMobileTableView"
    class="opc-pbx-comparison"
    :treeData="treeData"
    :colConfig="colConfig"
    tableRowClassName="opc-comparison-table">
    <template #button="{ col }">
      <template v-if="showAction">
        <zm-icon v-if="col.subType === subType" tabindex="-1" :aria-label="col.title + ' Selected'" class="check-icon"><CheckmarkSmall /></zm-icon>
        <zm-button
          v-else-if="col.btn"
          :data-testid="`checkout-button-phone-comparison-table-select-${col.key}`"
          :type="col.btn.type"
          :aria-label="col.btn.ariaLabel"
          @click="handleSure(col)"
        >
          {{ col.btn.label }}
        </zm-button>
      </template>
    </template>
  </PlanComparisonMobile>
  <zm-virtual-table
    v-if="!showMobileTableView"
    class="comparison-dialog__table"
    default-expand-all
    :span-method="arraySpanMethod"
    :data="treeData"
    :indent="0"
    row-key="id"
    :tree-props="{children: 'children'}"
    @row-click="handleRowClick"
    header-row-class-name="comparison-dialog__table-header"
    header-cell-class-name="comparison-dialog__table-header-cell"
    style="width: 965px"
    height="550px"
  >
    <zm-virtual-table-column
      class-name="comparison-dialog__feature-col"
      width="400">
      <template #default="scope" >
        <div :class="scope.row.subTitle ? `${scope.row.id}-sub-title` : ''">
          <span tabindex="-1" :class="[scope.row.subTitle ? 'sub-title' : 'sub-text']">
            {{scope.row.feature}}
            <zm-popover v-if="scope.row.tooltip" read-description focus-trap placement="top" trigger="hover">
              <template #content>
                <div v-html="scope.row.tooltip"></div>
              </template>
              <tips-icon data-testid="checkout-button-173" :aria-label="scope.row.feature" />
            </zm-popover>
          </span>
          <AutoExpireBadge :badgeId="scope.row.badgeId" theme="comparison" style="margin-left: 4px;" />
          <a data-testid="checkout-a-174" tabindex="-1" v-if="scope.row.pdf" href="https://zoom.us/docs/doc/Phone-NomadicE911-6-2020.pdf" target="_blank">{{$t('phone.fullPlanItem20Pdf')}}</a>
          <div v-if="scope.row.link">
            <a data-testid="checkout-a-175" tabindex="-1" v-if="scope.row.link.callback" href="javascript:void(0);" @click="scope.row.link.callback" :style="scope.row.link.style || {}" :aria-label="scope.row.link.ariaLabel||scope.row.link.text">{{scope.row.link.text}}</a>
          </div>
        </div>
      </template>
    </zm-virtual-table-column>
    <!--col config start-->
    <zm-virtual-table-column
      v-for="(col, idx) in colConfig"
      :key="col.key + idx"
      class-name="comparison-dialog__col"
      :width="isGSOn? '188' : '288'">
      <!-- eslint-disable -->
      <template #header>
        <div tabindex="-1" class="type-title">{{col.title}}</div>
        <template v-if="showAction">
          <zm-icon v-if="col.subType === subType" tabindex="-1" class="check-icon h-32" :aria-label="col.title + ' Selected'"><CheckmarkSmall /></zm-icon>
          <zm-button
            v-else-if="col.btn"
            :data-testid="`checkout-button-phone-comparison-table-select-${col.key}`"
            :type="col.btn.type"
            :aria-label="col.btn.ariaLabel"
            @click="handleSure(col)"
          >
            {{ col.btn.label }}
          </zm-button>
        </template>
      </template>
      <template #default="scope" >
        <template v-if="col.key !== 'enterprise'">
          <template v-if="scope.row.isString">
            <span tabindex="-1" v-html="scope.row[col.key]" v-if="scope.row[col.key]" ></span>
            <zm-icon v-else tabindex="-1" :aria-label="$t('notIncluded')"><Minus /></zm-icon>
          </template>
          <template v-else>
            <zm-icon v-if="scope.row[col.key] == true" tabindex="-1" class="check-icon" :aria-label="$t('included')"><CheckmarkSmall /></zm-icon>
            <zm-icon v-else tabindex="-1" :aria-label="$t('notIncluded')"><Minus /></zm-icon>
            <div tabindex="-1" class="cell-desc" v-html="scope.row.desc" v-if="scope.row.desc"></div>
          </template>
        </template>
        <template v-else>
          <template v-if="scope.row.isString">
            <span tabindex="-1" v-html="scope.row.enterprise" v-if="scope.row.enterprise"></span>
            <zm-icon v-else tabindex="-1" :aria-label="$t('notIncluded')"><Minus /></zm-icon>
            <div tabindex="-1" class="cell-desc" v-if="scope.row.enterpriseDesc">*{{scope.row.enterpriseDesc}}</div>
          </template>
          <template v-else>
            <template v-if="scope.row.enterprise">
              <zm-icon v-if="scope.row.enterprise === true" tabindex="-1" class="check-icon" :aria-label="$t('included')"><CheckmarkSmall /></zm-icon>
              <div v-else tabindex="-1">{{scope.row.enterprise}}</div>
              <div tabindex="-1" class="cell-desc" v-html="scope.row.enterpriseDesc || scope.row.desc" v-if="scope.row.enterpriseDesc || scope.row.desc"></div>
            </template>
            <zm-icon v-else tabindex="-1" :aria-label="$t('notIncluded')"><Minus /></zm-icon>
          </template>
        </template>
      </template>
    </zm-virtual-table-column>
    <!--col config end-->
  </zm-virtual-table>
</billing-dialog>
</template>
<script>
import { CheckmarkSmall, Minus } from '@zoom/icons-vue';
import { filter, get } from 'lodash';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { BILLING_CYCLE, planTypes, MODAL_QUERY_PARAMS } from '@/common/constants';
import { computedPbxCallingPlans, PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import { getPbxContactSalesLink } from '@/utils/i18n-shortcuts';
import BillingDialog from '@/components/billing-dialog.vue';
import { updateHrefWithQueryParams } from '@/utils';
import { navigateCurrentWindowTo } from '@/utils/modal-utils.js';

const ComparisonTypeMap = {
  CORE_FEATURES: 'coreFeatures',
  PHONE_FEATURES: 'phoneFeature',
  DEVICES_SUPPORT: 'devicesSupport',
  ZOOM_MEETINGS: 'zoomMeetings',
  INTEGRATIONS: 'integrations',
  CENTRALIZED_ADMINISTRATION: 'centralizedAdministration',
};

export default {
  name: 'FullComparisonDialog',
  mixins: [ConfirmComponent],
  data() {
    return {
      visible: false,
      pbxContactSalesLink: getPbxContactSalesLink(),
    };
  },
  props: {
    subType: String,
    showAction: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BillingDialog,
    CheckmarkSmall,
    Minus,
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['getSelectedPlans']),
    showMobileTableView() {
      return this.is_mobile_reactive || (this.$context.is.modal && !this.$context.is.modal2Column);
    },
    isGSOn(){
      return this.$config('enableZoomPhoneGlobalSelect')
    },
    isSupportOnlineFax () {
      const currentCountry = get(window.newBillingConfig, 'currentCountry', 'US');
      return ['US', 'CA'].includes(currentCountry);
    },
    treeData() {
      const mapItemKey = (data, pid) => data.map((item, idx) => ({
        ...item,
        id: `${pid}_${idx}`,
      }));
      const coreFeatures = this.coreFeatures.map((item, idx) => ({
        id: idx,
        ...item,
      }));
      return [
        ...coreFeatures,
        {
          feature: 'Phone Features',
          id: ComparisonTypeMap.PHONE_FEATURES,
          subTitle: true,
          children: mapItemKey(this.phoneFeature, ComparisonTypeMap.PHONE_FEATURES),
        },
        {
          feature: this.$t('phone.fullPlanItem26'),
          id: ComparisonTypeMap.DEVICES_SUPPORT,
          subTitle: true,
          children: mapItemKey(this.devicesSupport, ComparisonTypeMap.DEVICES_SUPPORT),
        },
        {
          feature: this.$t('phone.fullPlanItem30'),
          id: ComparisonTypeMap.ZOOM_MEETINGS,
          subTitle: true,
          children: mapItemKey(this.zoomMeetings, ComparisonTypeMap.ZOOM_MEETINGS),
        },
        {
          feature: this.$t('phone.fullPlanItem33'),
          id: ComparisonTypeMap.INTEGRATIONS,
          subTitle: true,
          children: mapItemKey(this.integrations, ComparisonTypeMap.INTEGRATIONS),
        },
        {
          feature: this.$t('phone.fullPlanItem39'),
          id: ComparisonTypeMap.CENTRALIZED_ADMINISTRATION,
          subTitle: true,
          children: mapItemKey(this.centralizedAdministration, ComparisonTypeMap.CENTRALIZED_ADMINISTRATION),
        },
      ];
    },
    colConfig() {
      return [
        {
          title: this.$t('phone.fullPlanMeterd'),
          key: 'metered',
          visible: true,
          subType: PBX_SUB_TYPES.METERED,
          btn: {
            label: this.$t('billing.common.select'),
            type: 'primary',
            link: '/',
            ariaLabel: 'Select metered',
          },
        },
        {
          title: this.$t('phone.fullPlanUnlimited'),
          key: 'unlimited',
          visible: true,
          subType: PBX_SUB_TYPES.UNLIMITED,
          btn: {
            label: this.$t('billing.common.select'),
            type: 'primary',
            ariaLabel: 'Select unlimited',
            link: '/',
          },
        },
        {
          title: this.$t('billing.pbx.global_select'),
          key: 'global',
          visible: this.isGSOn,
          btn: {
            label: this.$t('billing.common.select'),
            type: 'primary',
            ariaLabel: 'Select Global',
            link: updateHrefWithQueryParams('/opc/buy/config?plan=pbx&period=annual&type=basic2pro&from=pbx_ZSU&quantity=1&usageType=business', MODAL_QUERY_PARAMS),
          },
        },
      ].filter(v => v.visible)
    },
    currentBaseCategory() {
      const { planType, plans } = this.getCurrentBasePlanInfo;
      if(planType !== planTypes.ZOOM_MEETING || !plans[0]) {
        return '';
      }
      return get(plans, '0.zoomMeetingCategory', '');
    },
    selectedCallingPlan() {
      return computedPbxCallingPlans(this.getSelectedPlans)[0];
    },
    unlimitedCallingPlan() {
      const billingCycle = get(this, 'selectedCallingPlan.billing_cycle', BILLING_CYCLE.ANNUAL);
      return computedPbxCallingPlans(this.planMapFlat).find(item => item.billing_cycle === billingCycle && item.sub_type === PBX_SUB_TYPES.UNLIMITED);
    },
    meteredCallingPlan() {
      const billingCycle = get(this, 'selectedCallingPlan.billing_cycle', BILLING_CYCLE.ANNUAL);
      return computedPbxCallingPlans(this.planMapFlat).find(item => item.billing_cycle === billingCycle && item.sub_type === PBX_SUB_TYPES.METERED);
    },
    selectedZPIPlan() {
      return this.getSelectedPlans.find(item => item.type === planTypes.ZOOM_PHONE$ZPI)
    },
  },
  created() {
    this.install();
  },
  mounted() {
    this.$tracking.buyInteraction('product details', `zoom phone full plan comparison - impression`);
  },
  methods: {
    ...mapMutations(['removePlan', 'updateSelectPlan','setPbxCallingPlan']),
    onPBXSalesClick(event) {
      if (event?.target?.tagName === 'A') {
        this.$tracking.buyInteraction('product details',
          'zoom phone full plan comparison - contact sales');
      }
    },
    install() {
      this.coreFeatures = [{
        feature: this.$t('phone.fullPlanItem1'),
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem2'),
        pro: true,
        metered: true,
        unlimited: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem4'),
        tooltip: this.$t('phone.fullPlanItem4Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      },
      {
        feature: this.$t('billing.pbx.phone_support_24_7_live_chat'),
        tooltip: this.$t('billing.pbx.phone_support_24_7_live_chat_tip'),
        metered: true,
        unlimited: true,
        global: true,
      },
      {
        feature: this.$t('phone.fullPlanItem5'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem6'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }];

      this.phoneFeature = [{
        feature: this.$t('phone.fullPlanItem7'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem8'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem9'),
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem10'),
        tooltip: this.$t('phone.fullPlanItem10Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem11'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem12'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem13'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem14'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem15'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem16'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem17'),
        tooltip: this.$t('phone.fullPlanItem17Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem18'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem19'),
        tooltip: this.$t('phone.fullPlanItem19Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem20'),
        tooltip: this.$t('phone.fullPlanItem20Tip'),
        pdf: true,
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem21'),
        tooltip: this.$t('phone.fullPlanItem21Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem22'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem23'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem24'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      },
      {
        feature: this.$t('billing.phone_comparision.sms'),
        isString: true,
        metered: this.getSMSMeteredText('SMS'),
        unlimited: this.getSMSConfigByCountry(),
        global: this.getSMSConfigByCountry('global'),
      },
      {
        feature: this.$t('billing.phone_comparision.mms'),
        isString: true,
        metered: this.getSMSMeteredText('MMS'),
        unlimited: this.getSMSConfigByCountry(),
        global: this.getSMSConfigByCountry('global'),
      },
      {
        feature: this.$t('phone.fullPlanItem25'),
        tooltip: this.$t('phone.fullPlanItem25Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem51'),
        pro: false,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        shouldHide: !this.isSupportOnlineFax,
        feature: this.$t('phone.fullPlanItem61'),
        tooltip: this.$t('phone.fullPlanItem61Tip', { href: '/billing/pbx/rates' }),
        pro: false,
        metered: true,
        unlimited: true,
        select: false,
        global: false,
      }];

      this.devicesSupport = [{
        feature: this.$t('phone.fullPlanItem27'),
        tooltip: this.$t('phone.fullPlanItem27Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem28'),
        tooltip: this.$t('phone.fullPlanItem28Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem29'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }];

      this.zoomMeetings = [{
        feature: this.$t('phone.fullPlanItem31'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem32'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }];

      this.integrations = [{
        feature: this.$t('phone.fullPlanItem34'),
        tooltip: this.$t('phone.fullPlanItem34Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem35'),
        tooltip: this.$t('phone.fullPlanItem35Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem36'),
        tooltip: this.$t('phone.fullPlanItem36Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem37'),
        tooltip: this.$t('phone.fullPlanItem37Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem38'),
        tooltip: this.$t('phone.fullPlanItem38Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }];

      this.centralizedAdministration = [{
        feature: this.$t('phone.fullPlanItem40'),
        tooltip: this.$t('phone.fullPlanItem40Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem41'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem42'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem43'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem44'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem45'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem46'),
        tooltip: this.$t('phone.fullPlanItem46Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem47'),
        tooltip: this.$t('phone.fullPlanItem47Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      },
      // {
      //   feature: this.$t('phone.fullPlanItem48'),
      //   pro: true,
      //   metered: true,
      //   unlimited: true,
      //   select: true
      // },
      {
        feature: this.$t('phone.fullPlanItem49'),
        tooltip: this.$t('phone.fullPlanItem49Tip'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
        feature: this.$t('phone.fullPlanItem50'),
        pro: true,
        metered: true,
        unlimited: true,
        select: true,
        global: true,
      }, {
          feature: this.$t('phone.fullPlanSms'),
          tooltip: this.$t('phone.fullPlanSmsTip'),
          metered: true,
          unlimited: true,
        },
      ];

      this.phoneFeature = filter(this.phoneFeature, (item) => { return item.shouldHide !== true; });
    },
    handleRowClick(row) {
      if (row.subTitle) {
        const featureCol = document.querySelector(`.${row.id}-sub-title`);
        let cel = null;
        let expandBtn = null;
        if (featureCol) {
          cel = featureCol.parentElement;
        }
        if (cel) {
          expandBtn = cel.querySelector('.zbo-virtual-table__expand-icon>button');
        }
        if (expandBtn) {
          expandBtn.click();
        }
      }
    },
    arraySpanMethod({ row, columnIndex }) {
      if (row.subTitle) {
        return columnIndex === 0 ? [1, 10] : [0, 0];
      }
    },
    beforeClose(close) {
      this.$tracking.buyInteraction('product details', `zoom phone full plan comparison - exit`);
      close();
    },
    async handleSure(col) {
      if(col.key === 'global') {
        navigateCurrentWindowTo(col?.btn?.link, { replace: false });
        return;
      }
      const typeName = col.subType === PBX_SUB_TYPES.METERED ? 'metered' : 'unlimited regional';
      this.$tracking.buyInteraction('product details', `zoom phone full plan comparison select - ${typeName}`);
      let nextCallingPlan = this.unlimitedCallingPlan, license = get(this, 'selectedCallingPlan.cartInfo.selected_number', 1), needRemoveCallingPlanCode;
      if(this.selectedZPIPlan && col.subType === PBX_SUB_TYPES.METERED) {
        await this.$confirm(
          this.$t('billing.planform.pbx.auto_remove_unlimited_addons_info'),
          this.$t('billing.planform.pbx.auto_remove_unlimited_addons_title')
        );
        this.removePlan(this.selectedZPIPlan.plan_code);
      }

      if(this.selectedCallingPlan) {
        needRemoveCallingPlanCode = this.selectedCallingPlan.plan_code;
      }
      if(col.subType === PBX_SUB_TYPES.METERED) {
        nextCallingPlan = this.meteredCallingPlan;
      }
      nextCallingPlan && this.updateSelectPlan({
        plan_code: nextCallingPlan.plan_code,
        cartInfo: { selected_number: license },
      });
      nextCallingPlan && this.setPbxCallingPlan(nextCallingPlan?.sub_type)
      needRemoveCallingPlanCode && this.removePlan(needRemoveCallingPlanCode);
      return nextCallingPlan;
    },
    onBackEvent(){
      this.handleCancel();
    },
    getSMSConfigByCountry (prop = 'unlimited') {
      const currentCountry = get(window.newBillingConfig, 'currentCountry', '');
      const USCountry = ['US', 'PR', 'CA'];
      const AUCountry = ['AU', 'NZ'];
      const UKCountry = ['IE', 'GB'];
      const countryTextMap = new Map([
        [USCountry, this.$t('billing.phone_comparision.available_in_us')],
        [AUCountry, this.$t('billing.phone_comparision.available_in_au')],
        [UKCountry, this.$t('billing.phone_comparision.available_in_uk')],
      ]);
      let smsPropsText = '';
      for (const [countries, text] of countryTextMap.entries()) {
        if (countries.includes(currentCountry)) {
          smsPropsText = text;
          break;
        }
      }
      if (prop === 'global' && !USCountry.includes(currentCountry)) {
        smsPropsText = ''
      }
      return smsPropsText || false;
    },
     getSMSMeteredText (type) {
      const currentCountry = get(window.newBillingConfig, 'currentCountry', '');
      if (['US', 'PR', 'CA'].includes(currentCountry)) return this.$t('billing.phone_comparision.available_in_us');

      if (type === 'SMS') {
        if (['AU', 'NZ'].includes(currentCountry)) return this.$t('billing.phone_comparision.available_in_au_only');
        if (['IE', 'GB'].includes(currentCountry)) return this.$t('billing.phone_comparision.available_in_uk_only');
      }
      return false;
    }
  },
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.comparison-dialog {
  .check-icon {
    color: var(--zoom-color-fill-primary, #0d6bde);
    font-size: 16px;
  }
  .h-32 {
    height: 32px;
  }
  max-width: 1015px;
  width: auto !important;
  a {
    color: var(--zoom-color-fill-primary, #0d6bde);
  }

  .zbo-popover,
  .zbo-tooltip {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  }

  @include media(desktop) {
    &__title {
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
    }
    &__desc {
      font-style: normal;
      font-weight: 450;
      font-size: 14px;
      line-height: 120%;
      text-align: center;
      color: var(--zoom-color-text-neutral, #686F79);
    }
  }

  @include media(mobile, tablet) {
    &.opc-pbx-comparison-dialog &__title {
      color: var(--zoom-color-text-strong-neutral, #555B62);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
    }

    &.opc-pbx-comparison-dialog &__desc {
      color: var(--zoom-color-text-neutral, #686F79);
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      line-height: 120%; /* 16.8px */

      a {
        color: var(--zoom-color-fill-primary, #0d6bde);
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
      }
    }
  }

  &__table {
    border: 0 !important;
    td, th {
      border-right: none !important;
    }
    td,tr {
      padding: 0;
    }
    .cell {
      padding: 0;
    }
    td:first-child, &__table th:first-child {
      padding-left: 24px;
    }
    .zbo-virtual-table__row .cell:not(:has(>[class*=sub-title])) {
      .zbo-virtual-table__indent, .zbo-virtual-table__expand-icon {
        display: none;
      }
    }
  }
  &__table &__table-header-cell.comparison-dialog__col {
    font-style: normal;
    text-align: center;
    padding-top: 0;
    padding-bottom: 0;
    &:first-child {
      padding-left: 38px;
    }
    .cell {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 12px 4px;
      gap: 8px;
      .type-title {
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      }
    }
  }
  &__table &__feature-col {
    text-align: left;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    padding: 16px 0;
    .sub-title {
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      padding: 16px 0;
    }
    .cell:has(>[class*=sub-title]) {
      display: flex;
      flex-direction: row-reverse;
      justify-content: left;
    }
  }
  &__table &__col {
    text-align: center;
    padding: 16px 4px;
    .cell-desc {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 150%;
      text-align: center;
      color: var(--zoom-color-text-neutral, #686F79);
      display: block;
      margin-top: 4px;
    }
  }
}

@include media(mobile, tablet) {
  .comparison-dialog.opc-pbx-comparison-dialog {
    padding-top: 1px;

    .comparison-dialog__desc {
      padding: 0 24px;
    }
    .zbo-dialog {
      &__body {
        overflow-y: hidden;
        padding: 0;
      }

      &__header {
        padding-bottom: 10px;
      }
    }

    .comparison-tree-table-mobile {
      padding-top: 10px;

      &__header-selection-row {
        .selection-area {
          border-bottom: 0px;
        }
      }

      &__inside {
        padding-bottom: 20px;
      }

    }
  }
}

@include media(tablet) {
  .comparison-dialog.opc-pbx-comparison-dialog {
    &.zbo-dialog {
      width: calc(100% - 24px) !important;
      max-width: calc(100% - 24px) !important;
    }
    &.opc-modal-dialog.zbo-dialog{
      margin: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
    }
  }
}
</style>
